import React from 'react'
import { useDeleteRequest } from '../../hooks/request'
import { EMPLOYEES_DETAIL } from '../../urls'
import { useModal } from '../../hooks/modal'
import EmployeeUpdate from './EmployeeUpdate'
import Button from '../../components/common/Button'
import { getSalaryType } from '../../utils/types'

export default function EmployeeItem({ item, category, index }) {
    const brandRemove = useDeleteRequest({ url: EMPLOYEES_DETAIL.replace('{id}', item.id) })
    const [showUpdateModal, hideUpdateModal] = useModal(
        <EmployeeUpdate
            category={category}
            item={item}
            onSuccess={() => {
                category.request()
                hideUpdateModal()
            }}
            onCancel={() => hideUpdateModal()}
        />,
    )

    async function remove() {
        if (global.confirm('Сизни чинакамдан ўчиришни истайсизми?')) {
            await brandRemove.request()
            await category.request()
        }
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>{item.name}</td>
            <td>{getSalaryType(item.salaryType)}</td>
            <td>{item.dailyRate}</td>
            <td>{item.monthlySalary}</td>
            <td>{item.isActive ? 'Фаол' : 'Фаол эмас'}</td>
            <td>{item.phone}</td>
            <td>{item.position}</td>
            <td>
                <div className="has-text-right is-flex">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                    <Button onClick={remove} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
